import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useParams } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import { Navigation, EffectCoverflow } from "swiper/modules";
import { resolveMediaUrl } from "../../../firebase/helpers";
import Logo from "../../images/logo.png";

function InfoProduct() {
  const { projects } = useSelector((state) => state.projects);
  const { id } = useParams();
  const dispatch = useDispatch();
  const infoData = projects.filter((item) => item.id === id);

  return (
    <main className="content-wrapper">
      <div className="container">
        <nav aria-label="breadcrumb" className="position-relative pt-3 mt-3 mt-md-4 mb-4">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={"/"}>الرئيسية</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to={"/products"}>المنتجات</Link>
            </li>
            <li aria-current="page" className="breadcrumb-item active">
              تفاصيل المنتج
            </li>
          </ol>
        </nav>

        {infoData.map((item) => {
          const images = Array.isArray(item.images) && item.images.length
            ? item.images
            : [{ product_photo: Logo }];

          return (
            <section key={item.id} className="row pb-4 pb-md-5 mb-2 mb-md-0 mb-xl-3">
              <div className="col-md-7 col-xl-8 pb-4 pb-md-0 mb-2 mb-sm-3 mb-md-0">
                <Swiper
                  loop={images.length > 1}
                  grabCursor={true}
                  speed={600}
                  effect="coverflow"
                  coverflowEffect={{
                    rotate: 0,
                    scale: 1.02,
                    depth: 100,
                    stretch: 0,
                    slideShadows: false,
                  }}
                  navigation={true}
                  modules={[EffectCoverflow, Navigation]}
                  className="rounded-4 overflow-hidden"
                >
                  {images.map((img, index) => (
                    <SwiperSlide key={`${item.id}-${index}`} className="ratio ratio-1x1">
                      <img
                        alt={item.product_title_ar}
                        src={resolveMediaUrl(img.product_photo, Logo)}
                        className="w-100 h-100 object-fit-cover"
                      />
                    </SwiperSlide>
                  ))}
                </Swiper>
              </div>

              <div className="col-md-5 col-xl-4">
                <div className="d-none d-md-block" style={{ marginTop: "-90px" }} />
                <div className="sticky-md-top ps-md-2 ps-xl-4">
                  <div className="d-none d-md-block" style={{ paddingTop: "90px" }} />
                  <div className="fs-xs text-body-secondary mb-3">{item.product_code}</div>
                  <h1 className="fs-xl fw-medium">{item.product_title_ar}</h1>
                  <div className="h4 fw-bold mb-4">{item.product_price} د.ع</div>
                  <div className="mb-4">
                    <p
                      dangerouslySetInnerHTML={{
                        __html: item.product_description_ar || "لا يوجد وصف لهذا المنتج حاليًا.",
                      }}
                    />
                  </div>
                  <div className="d-flex gap-3 pb-4 mb-1 mt-4 mb-lg-3">
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href={`https://api.whatsapp.com/send?phone=+9647748999948&text=مرحبًا%0Aأنا أود شراء المنتج ${item.product_title_ar}%0Aرمز المنتج: ${item.product_code}%0Aالسعر: ${item.product_price}%0Aيرجى تقديم المزيد من المعلومات حول المنتج وكيفية الشراء.%0Aشكرًا.`}
                      data-action="share/whatsapp/share"
                      type="button"
                      className="btn btn-dark w-100 rounded-pill px-3"
                    >
                      طلب سريع
                    </a>
                    <button
                      onClick={() => {
                        dispatch({
                          type: "add",
                          id: item.id,
                          colorId: 2,
                        });
                      }}
                      aria-label="Add to cart"
                      className="btn btn-icon btn-lg btn-secondary rounded-circle animate-pulse"
                      type="button"
                    >
                      <i className="ci-shopping-cart animate-target" />
                    </button>
                  </div>
                </div>
              </div>
            </section>
          );
        })}
      </div>
    </main>
  );
}

export default InfoProduct;